export const CAMS_CARE_URL = 'https://cams-care.com/';
